import { AdGroupsGrid } from './ad-groups-grid';
import { getConfig } from './grid-config';
import { getAdGroupPlugins } from './plugins';


export function createAdGroupGrid({
  deps = null,
  dataSource,
  filterService,
  getAdditionalPlugins = () => [],
  preferenceConfig,
  preferenceService,
  router,
  scope,
  addDateChangeListener,
  p$daterange,
  isForVNext = false,
  viewport,
  adGroupTabPerfMarker,
  customHeaderOffset,
  currentCampaign,
  pageName,
  preexecuteFlag = false,
  globalCampaignTypeFilter,
  getCampaignTypeGlobalFilter,
  isDataFetchManagerSource,
}) {
  return new AdGroupsGrid({
    deps,
    isForVNext,
    filterService,
    getGridConfig: view => getConfig({
      dataSource,
      scope,
      view,
      filterService,
      preferenceConfig,
      router,
      isForVNext,
      viewport,
      customHeaderOffset,
      currentCampaign,
      deps,
      globalCampaignTypeFilter,
      isDataFetchManagerSource,
    }),
    getPlugins: view => getAdGroupPlugins({
      filterService,
      router,
      scope,
      isForVNext,
      addDateChangeListener,
      p$daterange,
      adGroupTabPerfMarker,
      currentCampaign,
      preexecuteFlag,
      globalCampaignTypeFilter,
      getCampaignTypeGlobalFilter,
      preferenceService,
    }).concat(getAdditionalPlugins(view)),
    router,
    scope,
    preferenceConfig,
    currentCampaign,
    pageName,
    preexecuteFlag,
    globalCampaignTypeFilter,
  });
}
